import { ref, computed } from 'vue'
import { trans } from 'laravel-vue-i18n'

export const FORM_COLOR_MAP = {
    blue:   '#2A6FDB',
    green:  '#1F8A5B',
    purple: '#8E5BC9',
    red:    '#D9544A',
    orange: '#D97757',
    yellow: '#D4A017',
    teal:   '#0D9488',
    indigo: '#5B5BD6',
    gray:   '#6B7280',
    pink:   '#C73E8C',
}

const COLLEAGUE_COLOR_PALETTE = [
    '#0F1115', '#D97757', '#2A6FDB', '#8E5BC9',
    '#1F8A5B', '#C73E8C', '#0D9488', '#5B5BD6',
]

export const FORM_TYPE_LABELS = {
    get personal()      { return trans('forms.type_personal_short') },
    get service()       { return trans('forms.type_service_short') },
    get rental()        { return trans('forms.type_rental_short') },
    get accommodation() { return trans('forms.type_accommodation_short') },
}

export function getFormColor(form) {
    return FORM_COLOR_MAP[form?.theme?.color] ?? '#6B7280'
}

export function getColleagueColor(index) {
    return COLLEAGUE_COLOR_PALETTE[index % COLLEAGUE_COLOR_PALETTE.length]
}

export function useReservationsCalendar(reservationForms, allEmployees) {
    const visibleFormIds = ref(new Set((reservationForms ?? []).map(f => f.id)))
    const visibleColleagueIds = ref(new Set((allEmployees ?? []).map(e => e.id)))

    function toggleForm(id) {
        const s = new Set(visibleFormIds.value)
        s.has(id) ? s.delete(id) : s.add(id)
        visibleFormIds.value = s
    }

    function toggleColleague(id) {
        const s = new Set(visibleColleagueIds.value)
        s.has(id) ? s.delete(id) : s.add(id)
        visibleColleagueIds.value = s
    }

    const visibleFormIdsArray = computed(() => [...visibleFormIds.value])
    const visibleColleagueIdsArray = computed(() => [...visibleColleagueIds.value])

    return {
        visibleFormIds,
        visibleColleagueIds,
        visibleFormIdsArray,
        visibleColleagueIdsArray,
        toggleForm,
        toggleColleague,
    }
}
